var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "absolute-fill frame",
    class: [_vm.frame]
  }, [!_vm.frameOnly || _vm.frameOnly == 'background' ? _c('div', {
    staticClass: "absolute-fill background"
  }) : _vm._e(), _c('div', {
    staticClass: "absolute-fill blob"
  }, [_vm._t("default")], 2), !_vm.frameOnly || _vm.frameOnly == 'foreground' ? _c('div', {
    staticClass: "absolute-fill foreground"
  }, [_c('div', {
    staticClass: "edge left"
  }), _c('div', {
    staticClass: "edge right"
  }), _c('div', {
    staticClass: "edge top"
  }), _c('div', {
    staticClass: "edge bottom"
  }), _c('div', {
    staticClass: "corner top-left"
  }), _c('div', {
    staticClass: "corner top-right"
  }), _c('div', {
    staticClass: "corner bottom-left"
  }), _c('div', {
    staticClass: "corner bottom-right"
  })]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }